module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/intro/intro_gradient_bg-8d3ccf6a0db636a9d535547ccfd6301b.png";